<template>
  <table>
    <thead />
    <tbody>
      <tr>
        <td>1</td>
        <td>fist person</td>
      </tr>
      <tr>
        <td>1pl</td>
        <td>fist person plural</td>
      </tr>
      <tr>
        <td>1pl.excl</td>
        <td></td>
      </tr>
      <tr>
        <td>1pl.incl</td>
        <td></td>
      </tr>
      <tr>
        <td>1sg</td>
        <td>fist person singular</td>
      </tr>
      <tr>
        <td>2</td>
        <td>second person</td>
      </tr>
      <tr>
        <td>2pl</td>
        <td>second person plural</td>
      </tr>
      <tr>
        <td>2sg</td>
        <td>second person singular</td>
      </tr>
      <tr>
        <td>3</td>
        <td>third person</td>
      </tr>
      <tr>
        <td>3fsg</td>
        <td>third person feminine singular</td>
      </tr>
      <tr>
        <td>3msg</td>
        <td>third person masculine singular</td>
      </tr>
      <tr>
        <td>3pl</td>
        <td>third person plural</td>
      </tr>
      <tr>
        <td>3sg</td>
        <td>third person singular</td>
      </tr>
      <tr>
        <td>adj</td>
        <td>adjective</td>
      </tr>
      <tr>
        <td>adv</td>
        <td>adverb(ial)</td>
      </tr>
      <tr>
        <td>autben</td>
        <td>autobenefactive (form)</td>
      </tr>
      <tr>
        <td>aux</td>
        <td>auxiliary (verb)</td>
      </tr>
      <tr>
        <td>aux.cond</td>
        <td></td>
      </tr>
      <tr>
        <td>aux.fut</td>
        <td></td>
      </tr>
      <tr>
        <td>caus</td>
        <td>causative (form)</td>
      </tr>
      <tr>
        <td>coll</td>
        <td>collective (noun)</td>
      </tr>
      <tr>
        <td>cond</td>
        <td>conditional (mood)</td>
      </tr>
      <tr>
        <td>cop</td>
        <td>copula</td>
      </tr>
      <tr>
        <td>cop.prs.dep</td>
        <td></td>
      </tr>
      <tr>
        <td>cop.prt</td>
        <td></td>
      </tr>
      <tr>
        <td>corp</td>
        <td>corporate (noun)</td>
      </tr>
      <tr>
        <td>decl</td>
        <td>declarative (sentence)</td>
      </tr>
      <tr>
        <td>decl.neg</td>
        <td></td>
      </tr>
      <tr>
        <td>def</td>
        <td>definite (form)</td>
      </tr>
      <tr>
        <td>def.sbj</td>
        <td></td>
      </tr>
      <tr>
        <td>dem</td>
        <td>demonstrative (form)</td>
      </tr>
      <tr>
        <td>dem.dist</td>
        <td></td>
      </tr>
      <tr>
        <td>dem.prox</td>
        <td></td>
      </tr>
      <tr>
        <td>dep</td>
        <td>dependent (form)</td>
      </tr>
      <tr>
        <td>det</td>
        <td>determinate (form)</td>
      </tr>
      <tr>
        <td>dist</td>
        <td>distal</td>
      </tr>
      <tr>
        <td>distr</td>
        <td>distributive (form)</td>
      </tr>
      <tr>
        <td>excl</td>
        <td>exclusive (form)</td>
      </tr>
      <tr>
        <td>f</td>
        <td>feminine (gender)</td>
      </tr>
      <tr>
        <td>f.coll</td>
        <td></td>
      </tr>
      <tr>
        <td>f.corp</td>
        <td></td>
      </tr>
      <tr>
        <td>fin</td>
        <td>final constituent</td>
      </tr>
      <tr>
        <td>foc</td>
        <td>focus</td>
      </tr>
      <tr>
        <td>foc.fin</td>
        <td>focus on final constitutent</td>
      </tr>
      <tr>
        <td>fut</td>
        <td>future (tense)</td>
      </tr>
      <tr>
        <td>gen</td>
        <td>genitive</td>
      </tr>
      <tr>
        <td>imp</td>
        <td>imperative (mood)</td>
      </tr>
      <tr>
        <td>imprs</td>
        <td>impersonal</td>
      </tr>
      <tr>
        <td>incl</td>
        <td>inclusive (form)</td>
      </tr>
      <tr>
        <td>inf</td>
        <td>infinitive</td>
      </tr>
      <tr>
        <td>m</td>
        <td>masculine (gender)</td>
      </tr>
      <tr>
        <td>m.coll</td>
        <td></td>
      </tr>
      <tr>
        <td>m.corp</td>
        <td></td>
      </tr>
      <tr>
        <td>neg</td>
        <td>negation</td>
      </tr>
      <tr>
        <td>noun</td>
        <td>noun (derived)</td>
      </tr>
      <tr>
        <td>noun.f</td>
        <td></td>
      </tr>
      <tr>
        <td>noun.m</td>
        <td></td>
      </tr>
      <tr>
        <td>num</td>
        <td>numerative (form)</td>
      </tr>
      <tr>
        <td>obj</td>
        <td>object</td>
      </tr>
      <tr>
        <td>opt</td>
        <td>optative (mood)</td>
      </tr>
      <tr>
        <td>part</td>
        <td>participle</td>
      </tr>
      <tr>
        <td>pass</td>
        <td>passive</td>
      </tr>
      <tr>
        <td>pl</td>
        <td>plural</td>
      </tr>
      <tr>
        <td>plt</td>
        <td>plurale tantum</td>
      </tr>
      <tr>
        <td>poss</td>
        <td>possessive (form)</td>
      </tr>
      <tr>
        <td>poss.3msg</td>
        <td></td>
      </tr>
      <tr>
        <td>pot</td>
        <td>potential (mood)</td>
      </tr>
      <tr>
        <td>pro</td>
        <td>pronoun</td>
      </tr>
      <tr>
        <td>pro.1pl.incl</td>
        <td></td>
      </tr>
      <tr>
        <td>pro.2</td>
        <td></td>
      </tr>
      <tr>
        <td>pro.dem</td>
        <td></td>
      </tr>
      <tr>
        <td>pro.imprs</td>
        <td></td>
      </tr>
      <tr>
        <td>pro.obj.1sg</td>
        <td></td>
      </tr>
      <tr>
        <td>pro.poss</td>
        <td></td>
      </tr>
      <tr>
        <td>prog</td>
        <td>progressive (aspect)</td>
      </tr>
      <tr>
        <td>proh</td>
        <td>prohibitive (mood)</td>
      </tr>
      <tr>
        <td>prox</td>
        <td>proximal</td>
      </tr>
      <tr>
        <td>prs</td>
        <td>present (tense)</td>
      </tr>
      <tr>
        <td>prs.dep</td>
        <td></td>
      </tr>
      <tr>
        <td>prt</td>
        <td>preterite (tense)</td>
      </tr>
      <tr>
        <td>q</td>
        <td>question / interrogative (form)</td>
      </tr>
      <tr>
        <td>refl</td>
        <td>reflexive</td>
      </tr>
      <tr>
        <td>rel</td>
        <td>relative</td>
      </tr>
      <tr>
        <td>sbj</td>
        <td>subject (form(</td>
      </tr>
      <tr>
        <td>sbjv</td>
        <td>subjunctive (mood)</td>
      </tr>
      <tr>
        <td>sg</td>
        <td>singular</td>
      </tr>
      <tr>
        <td>sglt</td>
        <td>singulative (form)</td>
      </tr>
      <tr>
        <td>v.noun</td>
        <td>verbal noun</td>
      </tr>
      <tr>
        <td>ven</td>
        <td>venitive (particle)</td>
      </tr>
      <tr>
        <td>voc</td>
        <td>vocative (form)</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {};
</script>

<style scoped>
table {
  font-size: smaller;
  width: auto;
}
td {
  padding: 0.1rem;
}
</style>
